import { useCallback } from 'react'

import Image from 'next/image'

import { Button } from '../../../v2/Button'
import { Row, Column } from '../../../v2/Grid'
import { LinkComponent } from '../../../v2/Link'
import { Text } from '../../../v2/Text'

import { useSearchUrlWithContractId } from 'hooks'

import { createMatchMaker, fetchQuestions } from 'services/match-maker'

import { useUser } from 'providers/UserProvider'

import { getContractFeatureValue, getDataContractId } from 'utils/helpers'

const Introduction = ({
	dispatch,
	handleContractSteps,
	hasContractFeature
}) => {
	const { user } = useUser()
	const { getSearchUrlWithContractId } = useSearchUrlWithContractId()

	const contractId = getDataContractId()?.integration?.contract?.id

	const startMatchMaking = useCallback(async () => {
		try {
			dispatch({ type: 'set_status', payload: 'loading' })

			const { data: matchMaker } = await createMatchMaker({
				...((user && { user_id: user.id, contract_id: user?.contract?.id }) || {
					contract_id: contractId
				})
			})
			const {
				data: { questions }
			} = await fetchQuestions(matchMaker.id_session)

			if (hasContractFeature) {
				const isHideConsultationValue = getContractFeatureValue(
					user?.contract,
					'hide_consultation_value'
				)
				const isPresentialConsultationsEnable = getContractFeatureValue(
					user?.contract,
					'presential_consultation_enabled',
					true
				)

				handleContractSteps(
					matchMaker.id_session,
					questions,
					isHideConsultationValue,
					isPresentialConsultationsEnable
				)
			}

			dispatch({
				type: 'start_session',
				payload: { id_session: matchMaker.id_session, questions }
			})
		} catch (error) {
			console.error(error)
		}
	}, [])

	return (
		<Row className='mx-0 w-screen flex-wrap items-center justify-center px-5 sm:!mx-20 sm:justify-between sm:px-[15px] md:px-0'>
			<Column className='mt-2.5 w-full justify-center sm:mt-[30px] sm:w-[30vw]'>
				<Text variant='big' className='text-xl font-bold md:text-2xl'>
					Queremos te ajudar a encontrar seu psicólogo
				</Text>
				<Text
					variant='small'
					className='mb-6 mt-5 text-gray-800 md:mb-5 md:mt-[50px] md:text-base lg:mb-[60px]'
				>
					Estamos construindo uma nova ferramenta que encontrará o profissional
					mais indicado pra você.{' '}
					<Text as='span' className='font-bold text-gray-800'>
						Teste e nos ajude a melhorar a sua experiência.
					</Text>
				</Text>
				<Button
					className='mb-[30px] h-[50px] rounded-lg'
					onClick={startMatchMaking}
				>
					Começar
				</Button>
				<Row className='mb-[50px] w-full justify-center'>
					<LinkComponent
						className='!underline'
						href={getSearchUrlWithContractId()}
						label={
							<Text
								variant='small'
								className='text-orange-600 underline md:text-base'
							>
								Prefiro buscar meu psicólogo sozinho
							</Text>
						}
					/>
				</Row>
			</Column>
			<Row className='order-first sm:order-1 md:order-1'>
				<Image
					src='/static/images/match-maker/00.png'
					width={440}
					height={470}
					alt='Ilustração vittude match'
					priority
				/>
			</Row>
		</Row>
	)
}

export { Introduction }
